import React from 'react';
import { Link } from 'react-router-dom'; // Only needed if using React Router
import './NotFound.css'; // optional for custom styles

const NotFound = () => {
  return (
    <div className="not-found-container">
      <h1 className="not-found-title">404</h1>
      <p className="not-found-message">Oops! The page you're looking for doesn't exist.</p>
      <Link to="/" className="not-found-link">Go back home</Link>
    </div>
  );
};

export default NotFound;
